import React from 'react';
import PropTypes from 'prop-types';
import { Container, Box } from './date.css';
import { format } from 'date-fns';

const ASIAN_COUNTRIES = ['India', 'China', 'Taiwan', 'Indonesia'];

function removeCountry(location) {
  const country = ASIAN_COUNTRIES.find(country => location.endsWith(country));
  if (country) {
    return location.slice(0, -2 + country.length * -1);
  }
  return location;
}

const Date = props => {
  const {
    additionalLabel,
    additionalUrl,
    directTicketLabel,
    directTicketLink,
  } = props;
  const { start, location, venue, performance } = props.event;
  const { date } = props;
  return (
    <Container>
      <Box>
        <div className="left">
          <div className="conertTime">
            {format(date || start.date, 'MMM D')}
          </div>
          <div className="details">
            <div className="venue">
              {venue.displayName} - {removeCountry(location.city)}
            </div>

            <div className="acts">
              {performance.length > 1 && <span>with</span>}
              {performance.length > 1
                ? performance
                    .filter(artist => artist.artist.displayName !== 'Lauv')
                    .slice(0, 3)
                    .map(perf => {
                      return (
                        <span key={perf.artist.displayName}>
                          {perf.artist.displayName}
                        </span>
                      );
                    })
                : null}
            </div>
          </div>
        </div>

        <div className="buttonWrapper">
          {additionalUrl && (
            <a
              className="buy"
              target="_blank"
              rel="noopener noreferrer"
              href={additionalUrl}
            >
              {additionalLabel}
            </a>
          )}
          {directTicketLink && (
            <a
              className="buy"
              target="_blank"
              rel="noopener noreferrer"
              href={directTicketLink}
            >
              {directTicketLabel}
            </a>
          )}
        </div>
      </Box>
    </Container>
  );
};

Date.propTypes = {
  additionalLabel: PropTypes.string,
  additionalUrl: PropTypes.string,
  date: PropTypes.string,
  directTicketLabel: PropTypes.string,
  directTicketLink: PropTypes.string,
  // start: PropTypes.object,
  // location: PropTypes.object,
  event: PropTypes.object,
  // venue: PropTypes.object,
  // performance: PropTypes.array,
  // uri: PropTypes.string,
};

export default Date;
